import * as Yup from 'yup';
import { maxDatePicker, minDatePicker } from '../../../../../utils/Constant';

export const MainFormSchema = Yup.object({
  customerSearch: Yup.string()
    .required('Customer ID is required'),
  shipDate: Yup.date().min(minDatePicker).max(maxDatePicker),
});
